__turbopack_context__.v({
  "cursorArrowNext": "style-module-scss-module__fgaXNW__cursorArrowNext",
  "cursorArrowPrev": "style-module-scss-module__fgaXNW__cursorArrowPrev",
  "cursorNext": "style-module-scss-module__fgaXNW__cursorNext",
  "cursorPrev": "style-module-scss-module__fgaXNW__cursorPrev",
  "cursorZone": "style-module-scss-module__fgaXNW__cursorZone",
  "customCursor": "style-module-scss-module__fgaXNW__customCursor",
  "customCursorVisible": "style-module-scss-module__fgaXNW__customCursorVisible",
  "fade": "style-module-scss-module__fgaXNW__fade",
  "gallery": "style-module-scss-module__fgaXNW__gallery",
  "mainImage": "style-module-scss-module__fgaXNW__mainImage",
  "mainSwiper": "style-module-scss-module__fgaXNW__mainSwiper",
  "mainSwiperSlide": "style-module-scss-module__fgaXNW__mainSwiperSlide",
  "thumbSlide": "style-module-scss-module__fgaXNW__thumbSlide",
  "thumbsSwiper": "style-module-scss-module__fgaXNW__thumbsSwiper",
  "thumbsSwiperActive": "style-module-scss-module__fgaXNW__thumbsSwiperActive",
  "wrapper": "style-module-scss-module__fgaXNW__wrapper",
});
